import { callAuthAPI } from 'react-morel-auth';
import { PostPartnerService } from '../../../../../types/partner';

export const postPartnerService = (partnerService: Partial<PostPartnerService>) => {
  return callAuthAPI('/partner/service', '', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(partnerService),
  });
};
